<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import { customerSettings } from '../../../stores/api';
    import Select from "../../shared/Select.svelte";
    export let update: ()=>void;

    let items: {id: string, label: string}[] = [];

    $: {
        items = $customerSettings?.send_methods.filter(method => method.enabled).map((method) => {
            return {id: method.id, label: $_(method.id)};
        });
    }
</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('settings-sms-recipients')}</div>
    <div slot="content">
        {#if $customerSettings?.send_methods && $customerSettings?.send_methods.hasOwnProperty('length')}
            <div class="settings-group">
                <div class="settings-label">{$_('Send')}</div>
                <Select bind:selected={$customerSettings.send_method} {items} onChange={(s)=>{update(); return true;}} />
            </div>
        {/if}
        {#if $customerSettings?.send_method!=='send_method_no'}
            <div class='settings-group'>
                <div class="settings-label">{$_('Contents')}</div>
                <textarea
                    class="settings-value"
                      bind:value={$customerSettings.send_contents}
                      on:change={update}
                />
            </div>
        {/if}
    </div>
</TemplateSettingsGeneral>

<style>
    .settings-group {
        display: flex;
        align-items: center;
        column-gap: 10px;
        justify-content: flex-start;
        min-height: 33px;
        font-size: 14px;
    }
    .settings-label {
        flex: 0 1 160px;
        /*min-width: 90px;*/
        white-space: nowrap;
    }
    .settings-value {
        flex: 1 1 auto;
        box-sizing: border-box;
        /*width: 100%;*/
        padding: var(--input-small-padding);
        /*margin: 0 3px;*/
        background-color: #ffffff;
        border: var(--input-small-border);
        border-radius: var(--input-small-border-radius);
        font-family: inherit;
        font-size: var(--input-small-font-size);
        min-height: 90px;
        color: var(--input-small-color);
        /*wid*/

    }
    .settings-select{
        box-sizing: border-box;
        width: 100%;
        padding: 3px 6px;
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        border-radius: 4px;
        font-family: inherit;
    }
</style>
